import React, { useEffect, useRef, useState } from "react";
import Card from "../../shared/Card";
import axios from "axios";
import { AgGridDataTable } from "../../shared";

export default function Verifications(props) {
  const agGridRef = useRef();
  const [data, setData] = useState([]);
  const columnDefs = [
    { headerName: "Year", field: "VerifYear", width: 100 },
    {
      headerName: "Status",
      field: "Status",
      cellRenderer: function (params) {
        if (params.value != null) {
          var color = params.value === "INCOMPLETE" ? "red" : "green";
          return `<span style="color:${color}">${params.value}</span>`;
        }
      },
    },
    { headerName: "Method", field: "Type", width: 120 },
    { headerName: "VQ Number (eVQ)", field: "VqNumber", width: 165 },
    { headerName: "Completion Date", field: "SignDate", width: 150 },
    { headerName: "Signed By", field: "SignBy" },
  ];

  useEffect(() => {
    agGridRef.current.api.showLoadingOverlay();
    axios
      .get(`api/v1/hwts/search/facility/verifications?epaid=${props.EPA_ID}`)
      .then((res) => {
        setData(res.data);
        var allColumnIds = [];
        agGridRef.current.columnApi.getAllColumns().forEach((column) => {
          allColumnIds.push(column.colId);
        });
        agGridRef.current.columnApi.autoSizeColumns(allColumnIds, false);
        agGridRef.current.api.sizeColumnsToFit();
        agGridRef.current.columnApi.autoSizeAllColumns();
        agGridRef.current.api.hideOverlay();
        if (res.data.length < 1) agGridRef.current.api.showNoRowsOverlay();
      });
  }, [props.EPA_ID]);

  return (
    <Card
      cardType="default"
      cardHeader="Annual ID Number Verification History"
      headerColor="#046B99"
      headerTextColor="white"
      cardBody={
        <div className="verifications-card">
          <AgGridDataTable
            pageTitle={"Annual ID Number Verification History"}
            formParams={[]}
            agGridRef={agGridRef}
            columnDefs={columnDefs}
            rowData={data}
            initialPageSize={10}
            hideCsvExport={true}
            hideRecordCnt={true}
          />
        </div>
      }
      cardColor="white"
    />
  );
}
